<shared-forklift-right-route-header [detail]="detail"></shared-forklift-right-route-header>
<options *ngIf="detail" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>

<shared-active-slots-item-driverplate [route]="route" *ngIf="option=='DRIVERPLATE'"
    (refresh)="onRouteRefresh($event)"></shared-active-slots-item-driverplate>

<shared-phase-cmr-edit [phaseId]="detail?.phaseId" *ngIf="option=='EDITCMR'" (routeRefresh)="onRouteRefresh($event)"></shared-phase-cmr-edit>

<shared-phase-cmr [phaseId]="detail?.phaseId" *ngIf="option=='SIGNCMR'" [defaultSign]="true" [contract]="true"></shared-phase-cmr>
